import { FlexAligner, Typography } from '@scaleaq/scaleui';
import { useTranslation } from 'react-i18next';

import { filterClassLabelKey, formatFilterLabels } from './fishObservationGallery.functions.ts';
import { OrbitOneGalleryFilterClass } from './fishObservationGallery.types.ts';

type FishObservationGalleryEmptyStateProps = {
  /** Selected lice classes; empty means no filter is active. */
  filters: OrbitOneGalleryFilterClass[];
  availableFilterClasses: OrbitOneGalleryFilterClass[];
};

/** Shown when the gallery has no fish observations for the selected day and filters. */
export const FishObservationGalleryEmptyState = ({
  filters,
  availableFilterClasses,
}: FishObservationGalleryEmptyStateProps) => {
  const { t } = useTranslation('orbitOne');

  const hasActiveFilter = filters.length > 0 && filters.length < availableFilterClasses.length;
  const message = hasActiveFilter
    ? t('liceCount.imageGallery.noObservationsWithFilter', {
        filters: formatFilterLabels({
          filters,
          labelForClass: filterClass =>
            t(filterClassLabelKey({ filterClass, availableFilterClasses })),
        }),
      })
    : t('liceCount.imageGallery.noObservations');

  return (
    <FlexAligner alignment={'center'}>
      <Typography type='body_xlarge'>{message}</Typography>
    </FlexAligner>
  );
};
